import './CreateAnimal.css';

export default function CreateAnimal() {
  return (
    <div className="create-animal-page">
      <div className="create-animal-container">
        <h1>Добавить животное</h1>
        <div className="create-animal-content">
          <p>Здесь будет форма создания животного</p>
        </div>
      </div>
    </div>
  );
}
